import { TemplateResult, html, CSSResultGroup } from 'lit';
import { property } from 'lit/decorators.js';
import { BlocksElement } from '../BlocksElement';
import styles from './table-header.styles';

/**
 * @slot default - The table header content
 * @csspart base - The component's base wrapper.
 * @csspart part-default - The component's default slot.
 */
export class BlocksTableHeader extends BlocksElement {static styles: CSSResultGroup = styles;

  /**
   * Frozen
   * - Makes the table header frozen on scroll
   */
  @property({ type: Boolean })
  isFrozen: boolean | undefined;

  render(): TemplateResult<1> {
    const componentClassName = this.componentClassNames('cat-c-table-header', {
      'cat-c-table-header--frozen': this.isFrozen === true
    });

    return html` <div part="base" role="rowgroup" class="${componentClassName}"><slot part="part-default"></slot></div> `;
  }
}

if (customElements.get('cat-table-header') === undefined) {
  customElements.define('cat-table-header', BlocksTableHeader);
}

declare global {
  interface HTMLElementTagNameMap {
    'cat-table-header': BlocksTableHeader;
  }
}
